import { t } from '@lingui/core/macro'

import type { Storage } from '@jotta/grpc-connect-openapi/storage'

export const formatBytes = (bytes: bigint | number): string => {
  if (bytes < 0) {
    return '∞'
  }
  const units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const kilo = Number(1000)
  let unitIndex = 0
  let value = Number(bytes)

  // Convert bytes to appropriate unit
  while (value >= kilo && unitIndex < units.length - 1) {
    value /= kilo
    unitIndex++
  }
  value = Math.round(value * 10) / 10
  const formattedValue = value % 1 === 0 ? value.toString() : value.toFixed(1)

  return `${formattedValue}\u00a0${units[unitIndex]}`
}

export const formatStorage = (storage: Storage): string | undefined => {
  switch (storage.type.case) {
    case 'unlimited':
      return t`Unlimited\u00a0storage`
    case 'bytes':
      return formatBytes(storage.type.value)
    case undefined:
      return undefined
  }
}
